import { render } from "./MobileProduct.vue?vue&type=template&id=dd8792e4&scoped=true"
import script from "./MobileProduct.vue?vue&type=script&lang=js"
export * from "./MobileProduct.vue?vue&type=script&lang=js"

import "./MobileProduct.vue?vue&type=style&index=0&id=dd8792e4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd8792e4"]])

export default __exports__